/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
var decorate = function ($popoverContainer, excludeCb, clickCb, closeCb) {
  var self = this;
  $popoverContainer.off('display.bs.popover');
  $popoverContainer.on('display.bs.popover', function (e) {
    registerForPopoverDismiss();
  });
  registerForPopoverDismiss();
  $popoverContainer.off('hidden.bs.popover displayNone.bs.popover');
  $popoverContainer.on('hidden.bs.popover displayNone.bs.popover', function (e) {
    $('html').off('click.popoverDismiss');
    if (_.isFunction(closeCb)) {
      closeCb(e);
    }
  });
  function registerForPopoverDismiss() {
    $('html').off('click.popoverDismiss');
    $('html').on('click.popoverDismiss', function (e) {
      var exclude = excludeCb($popoverContainer, e);
      if (exclude === false && _.isFunction(clickCb)) {
        clickCb(e);
      }
    });
  }
};
export default {
  decorate: decorate
};

